export default __webpack_public_path__ + "5a10106c2788ec958233e1fe28641e57.webp";